import { render, staticRenderFns } from "./AnimatedNumber.vue?vue&type=template&id=0a4516e8&scoped=true&lang=pug&"
import script from "./AnimatedNumber.vue?vue&type=script&lang=js&"
export * from "./AnimatedNumber.vue?vue&type=script&lang=js&"
import style0 from "./AnimatedNumber.vue?vue&type=style&index=0&id=0a4516e8&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4516e8",
  null
  
)

export default component.exports